/* eslint-disable max-len */
import { motion } from 'framer-motion'
import React from 'react'

export default function TextSection({text,show,from, wrapText}) {
    return (
        <motion.div 
            id="gstuploadInfo"
            initial={{ opacity: 0, scale: 1 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0 }}
            role="tooltip" 
            className={` ${wrapText === undefined ? ' w-max  h-5 absolute z-10' : ' z-10 max-w-[500px] 2xl:max-w-[700px] h-full break-all' } ${show?'visible':'invisible'} inline-block ${from === 'academicreports' ? 'left-0 bottom-[-4px]' : 'left-[28px]'} text-xs font-medium leading-[18px] text-[#031624] pt-[1.4px] px-3 bg-[#D0D5DD] rounded-sm`}
        >
            {text}
            <div className="tooltip-arrow" data-popper-arrow></div>
        </motion.div> 
    )
}
